export default __webpack_public_path__ + "static/media/logo.1ab8dd74.svg";